module.exports = __webpack_public_path__ + "img/list4.9af9993b.png";